import Vue from 'vue';
import i18n from "../../../i18n";


export default {

  async fetchConfigurations({ commit }, { pId, vId, pvId }) {
    Vue.$log.debug('loading activity configuration for', pId, vId);
    let query = '?pId=' + (pId || '') + '&vId=' + (vId || '') + '&pvId=' + (pvId || '');
    return Vue.axios.get(Vue.$url("configuration" + query))
      .then((rsp) => commit("SET_CONFIGURATIONS", rsp.data));
  },

  async fetchNextMaxCode({ commit }, { pId = null, vId = null }) {
    Vue.$log.debug('loading configuration next code for', pId, vId);
    let query = '?pId=' + (pId || '') + '&vId=' + (vId || '');
    return Vue.axios.get(Vue.$url("configuration/max-code" + query))
      .then((rsp) => {
        commit('SET_NEXT_SEQ_CODE', rsp.data);
        return rsp.data;
      })
  },

  async createConfiguration({ commit }, payload) {
    return Vue.axios
      .post(Vue.$url("configuration"), payload)
      .then((rsp) => {
        Vue.$log.debug("configuration created and saved under", rsp.data.id);
        commit('mShowInfoMessage', i18n.t('common.saved', { 0: 'Configuration', 1: payload.description }), { root: true });
      })
  },

  async deleteConfiguration({ commit }, payload) {
    Vue.$log.debug('trying to delete Configuration', payload.id);
    return Vue.axios
      .delete(Vue.$url("configuration/" + payload.id))
      .then(() => {
        commit('mShowInfoMessage', i18n.t('common.lockupdate', { 0: payload.description }), { root: true });
      });
  },

  async updateConfiguration({ commit }, payload) {
    return Vue.axios
      .put(Vue.$url("configuration/" + payload.id), payload)
      .then(() => {
        commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'Configuration', 1: payload.description }), { root: true });
      });
  },
}